import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { NotesSection } from "../../common/components/notes/NotesSection";
import { OrderAirlinesDataProvider } from "../../common/data-providers/OrderAirlinesDataProvider";
import { OnPremOrderAssetsSection } from "./assets/OnPremOrderAssetsSection";
import { OnPremOrderDeliverySection } from "./delivery/OnPremOrderDeliverySection";
import { OnPremOrderDetailsSection } from "./details/OnPremOrderDetailsSection";
import { OnPremOrderMaterialSpecificationSection } from "./material-specification/OnPremOrderMaterialSpecificationSection";
import { OnPremOrderDashboardHeader } from "./OnPremOrderDashboardHeader";

export const OnPremOrderDashboard: React.FC = () => {
    return (
        <>
            <OnPremOrderDashboardHeader />
            <Grid>
                <GridRow style={{ display: "flex", alignItems: "stretch" }}>
                    <GridColumn sm={6}>
                        <OnPremOrderDetailsSection minHeight={400} />
                    </GridColumn>
                    <GridColumn sm={6}>
                        <OnPremOrderDeliverySection minHeight={400} />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <OrderAirlinesDataProvider>
                            <OnPremOrderAssetsSection minHeight={400} />
                        </OrderAirlinesDataProvider>
                    </GridColumn>
                </GridRow>
                <GridRow style={{ display: "flex", alignItems: "stretch" }}>
                    <GridColumn sm={6} style={{ display: "flex" }}>
                        <OnPremOrderMaterialSpecificationSection minHeight={400} />
                    </GridColumn>
                    <GridColumn sm={6} style={{ display: "flex" }}>
                        <NotesSection style={{ minHeight: 400, flex: 1 }} />
                    </GridColumn>
                </GridRow>
            </Grid>
        </>
    );
};
